import b from 'b_';
import React, { CSSProperties, ReactNode } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { SimpleCallback } from '../../../typings';

import './datetimepicker__popup.scss';

interface OwnProps {
    style: CSSProperties;
    visible: boolean;
    withNow: boolean;
    setNow: SimpleCallback;
    nowLabel?: string;
    children: ReactNode;
    refCallback?: (element: HTMLDivElement) => void;
}

interface HOCProps {
    intl: IntlShape;
}

interface Props extends OwnProps, HOCProps {}

const DatetimepickerPopup = ({ nowLabel, setNow, style, visible, withNow, children, refCallback, intl }: Props) => {
    const labelForNowButton = nowLabel || intl.formatMessage({ id: 'datepicker.defaultNowLabel' });

    return (
        <div className={b('datetimepicker__popup', { visible })} ref={refCallback} style={style}>
            {children}
            {withNow && (
                <div className="datetimepicker__popup-now" onClick={setNow}>
                    {labelForNowButton}
                </div>
            )}
        </div>
    );
};

export default injectIntl(DatetimepickerPopup);
